import { SnackbarProvider } from "notistack";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import EventsCalenderLink from "./EventsCalendarLink";
import InitOrg from "./InitOrg";

import { setLocalizationMoment } from "./helper/dateFormat";
import ExternalLinkDonation from "./pages/ExternalLinkDonation";
import { EventLink } from "./pages/ExternalLinkEvents";
import { FormLink } from "./pages/ExternalLinkForms";
import { SchoolLink } from "./pages/ExternalLinkSchool";
import { ChargesLink } from "./pages/MemberLink/PayFromExternalLink";
import { getLocalStorageItem } from "./utils/functions";
import { MembershipForm } from "./pages/ExternalLinkForms/FormComponents/MembershipForm/MembershipForm";
import { UpdatePayment } from "./pages/ExternalLinkUpdatePayment/UpdatePayment";
import { FundraisingLink } from "./pages/ExternalLinkFundraising";
import { Fonts, FontFamilies } from "theme/fontConfig";

const Application = (props) => {
  const orgName = localStorage.getItem("orgName") || "Easyshul.com";
  const country = getLocalStorageItem("country", true);

  useEffect(() => {
    if (country?.code) {
      setLocalizationMoment(country?.local);
    }
  }, [country]);

  return (
    <>
      <Helmet>
        <title>{orgName}</title>
      </Helmet>
      <Router>
        <Switch>
          <Route
            path="/donation"
            render={() => (
              <SnackbarProvider
                maxSnack={1}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={4000}
                style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
              >
                <ExternalLinkDonation external={true} />
              </SnackbarProvider>
            )}
          />
          <Route path="/school" render={() => <SchoolLink />} />
          <Route
            path="/events-calendar"
            render={() => <EventsCalenderLink />}
          />
          <Route path="/charges" render={() => <ChargesLink />} />
          <Route path="/events" render={() => <EventLink />} />
          <Route path="/form" render={() => <FormLink />} />
          <Route path="/fundraising" render={() => <FundraisingLink />} />
          <Route
            path="/membership-form/:id"
            render={() => (
              <SnackbarProvider
                maxSnack={1}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={4000}
                style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
              >
                <MembershipForm />
              </SnackbarProvider>
            )}
          />
          <Route
            path="/paymentmethod"
            render={() => (
              <SnackbarProvider
                maxSnack={1}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={4000}
                style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
              >
                <UpdatePayment />
              </SnackbarProvider>
            )}
          />

          <Route path="/">
            <InitOrg />
          </Route>
        </Switch>
      </Router>
    </>
  );
};

export default Application;
